import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { strings } from "../../utils/constants";
import { FaWindows, FaApple, FaDownload } from "react-icons/fa";

const DownloadButton = ({ link, oldVersion, os }) => {
  const { t } = useTranslation();
  
  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = link;
    a.download = "";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const getIcon = () => {
    if (os === "WindowsOS") {
      return <FaWindows size={24} className="me-2" />;
    } else if (os === "MacOS") {
      return <FaApple size={24} className="me-2" />;
    } else {
      return <FaDownload size={20} className="me-2" />;
    }
  };

  return (
    <Link 
      className="btn btn--primary d-inline-flex align-items-center justify-content-center px-4 py-2" 
      onClick={handleDownload}
      style={{ minWidth: "200px" }}
    >
      {getIcon()}
      <span>
        {oldVersion ? t(strings.words.UPDATE) : t(strings.words.DOWNLOAD)}
      </span>
      <FaDownload className="ms-2" size={16} />
    </Link>
  );
};

export default DownloadButton;
